var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetingReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    fill: "#0B45DB",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.25C25.4746 0.25 32.75 7.52537 32.75 16.5C32.75 25.4746 25.4746 32.75 16.5 32.75C7.52537 32.75 0.25 25.4746 0.25 16.5C0.25 7.52537 7.52537 0.25 16.5 0.25Z",
    stroke: "#0B45DB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5495 17.1679C14.8358 17.5507 15.201 17.8674 15.6205 18.0966C16.04 18.3257 16.5038 18.462 16.9806 18.4962C17.4573 18.5303 17.9359 18.4615 18.3837 18.2945C18.8315 18.1274 19.2382 17.866 19.5761 17.5279L21.5761 15.5279C22.1833 14.8993 22.5193 14.0573 22.5117 13.1833C22.5041 12.3093 22.1536 11.4732 21.5355 10.8552C20.9175 10.2372 20.0815 9.88663 19.2075 9.87903C18.3335 9.87144 17.4915 10.2074 16.8628 10.8146L15.7161 11.9546",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2161 15.8328C16.9298 15.4501 16.5646 15.1334 16.1451 14.9042C15.7257 14.675 15.2618 14.5388 14.785 14.5046C14.3083 14.4705 13.8298 14.5393 13.3819 14.7063C12.9341 14.8734 12.5274 15.1348 12.1895 15.4728L10.1895 17.4728C9.58229 18.1015 9.24631 18.9435 9.2539 19.8175C9.2615 20.6915 9.61206 21.5275 10.2301 22.1456C10.8481 22.7636 11.6842 23.1142 12.5581 23.1217C13.4321 23.1293 14.2741 22.7934 14.9028 22.1862L16.0428 21.0462",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetingReport);
export default __webpack_public_path__ + "static/media/targeting-report.f041132fdc8fc183026fb6eb696bfd8a.svg";
export { ForwardRef as ReactComponent };